import { Component, Prop, Vue } from "vue-property-decorator";
import ProgressBar from "@/components/ProgressBar.vue";
import { CreateElement } from "vue";

@Component({
  components: {
    ProgressBar
  }
})
export default class Home extends Vue {
  render(h: CreateElement) {
    return (
      <v-container fluid class="fill-height">
        <v-row justify="center">
          <v-col cols="3">
            <v-card class="elevation-12" to="/balli" disabled>
              <v-toolbar color="#26A69A">
                <v-toolbar-title>1. BALLI</v-toolbar-title>
              </v-toolbar>
              <v-card-actions class="justify-center">
                <v-btn fab icon x-large to="/balli">
                  <v-img
                    src={require("@/assets/balli.png")}
                    class="justify-center"
                    height="70px"
                    width="50px"
                  />
                </v-btn>
              </v-card-actions>
              <v-card-text>
                Assessment of Ability, Attitude towards Learning, Regulation,
                and Grit
              </v-card-text>
              <v-card-actions>
                <v-progress-linear
                  value={Math.round(
                    (this.$store.getters.progressBalli /
                      this.$store.getters.numBalliQuestions) *
                      100
                  )}
                  height="4"
                  opacity="0.3"
                  striped={true}
                ></v-progress-linear>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card class="elevation-12" to="/bala" disabled={true}>
              <v-toolbar color="secondary">
                <v-toolbar-title>2. BALA</v-toolbar-title>
              </v-toolbar>
              <v-card-actions class="justify-center">
                <v-btn fab icon x-large to="/bala">
                  <v-img
                    src={require("@/assets/bala.png")}
                    class="justify-center"
                    width="50px"
                  />
                </v-btn>
              </v-card-actions>
              <v-card-text>
                Assessment of Reading Comprehension and Writing Skills
              </v-card-text>
              <v-card-actions>
                <v-progress-linear
                  value={Math.round(this.$store.getters.progressBala)}
                  height="4"
                  opacity="0.3"
                  striped={true}
                ></v-progress-linear>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card class="elevation-12" to="/talk2mejr">
              <v-toolbar color="warning">
                <v-toolbar-title>3. TALK2ME JR.</v-toolbar-title>
              </v-toolbar>
              <v-card-actions class="justify-center">
                <v-btn fab icon x-large to="/talk2mejr">
                  <v-img
                    src={require("@/assets/talk2mejr.png")}
                    class="justify-center"
                    width="50px"
                  />
                </v-btn>
              </v-card-actions>
              <v-card-text>
                Innovative and Interactive Language and Learning Tasks
              </v-card-text>
              <v-card-actions>
                <v-progress-linear
                  value={this.$store.getters.progressTTMJ}
                  height="4"
                  opacity="0.3"
                  striped={true}
                ></v-progress-linear>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    );
  }
}

const component = Home;
